var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-button',{staticStyle:{"color":"#faad14"},attrs:{"icon":"edit","size":"small","type":"link","disabled":_vm.disabled},on:{"click":e => _vm.$emit('click', e)}},[_vm._v(" 编辑 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }